import { configureStore } from '@reduxjs/toolkit';
import apiSlice from './actions/apiSlice';
import dashboardTitle from './actions/dashboardTitle';
import userTypeSlice from './actions/userTypeSlice';
import setRoleStore from './actions/setRoleStore';
import GetHeaderRolesSlice from './actions/GetHeaderRolesSlice';
import SupplierDropdownListSlice from './actions/SupplierDropdownListSlice';
import SupplierDropdownFilterSlice from './actions/SupplierDropdownFilterSlice'
import PostInviteSupplierListSlice from './actions/PostInviteSupplierListSlice';
import GetAdminSupplierUserListSlice from './actions/GetAdminSupplierUserListSlice';
import DeleteAdminSupplierSlice from './actions/DeleteAdminSupplierSlice';
import GetEmailDomainSupplierListSlice from './actions/GetEmailDomainSupplierListSlice';
import SupplierForecastTableDataReducer from './actions/SupplierForecastTableDataSlice';
import SupplierForecastSearchTableReducer from './actions/SupplierForecastSearchTableSlice';
import PUTEditInviteUserSlice from './actions/PUTEditInviteUserSlice';
import ForecastHistoryTableReducer from './actions/ForecastHistoryTableSlice';
import SupplierForecastSaveDataReducer from './actions/SupplierForecastSaveDataSlice';
import PostHideColumnsSlice from './actions/PostHideColumnsSlice';
import GetHideColumnsListSlice from './actions/GetHideColumnsListSlice';
import FileUploadSlice from './actions/FileUploadSlice';
import getforecastEmailSlice from './actions/forecastEmailSlice';
import getReasonCodeSlice from './actions/getReasonCodeSlice';
import deleteReasonCodeSlice from './actions/deleteReasonCodeSlice';
import putEditReasonCodeSlice from './actions/putEditReasonCodeSlice';
import postReasonCodeSlice from './actions/postReasonCodeSlice';
import getBuyerDropdownFilter from './actions/BuyerDropdownFilterSlice';
import getBuyerForecastTableData from './actions/getBuyerForecastTableData';
import getBuyerForecastSearchTable from './actions/BuyerForecastSearchTableSlice';
import getBuyerForecastSaveDataSlice from './actions/BuyerForecastSaveDataSlice';
import submitBuyerForecastOverrideDataSlice from './actions/submitBuyerForecastOverrideDataSlice';
import getPOExceptionMgmtBuyerTable from './actions/getPOExceptionMgmtBuyerTable';
import getMaterialBatchData from './actions/getMaterialBatchDataSlice';
import setRegionPlantStore from './actions/setRegionPlantStore';
import getPlantsRegionSlice from './actions/getPlantsRegionSlice';
import getSupplierEmailsSlice from './actions/getSupplierEmailsSlice';
import addToSupplierEmailsSlice from './actions/addToSupplierEmailsSlice';
import sendMailToSupplierSlice from './actions/sendMailToSupplierSlice';
import sendToSupplierSlice from './actions/sendToSupplierSlice';
import getSupplierPortalDataSlice from './actions/getSupplierPortalDataSlice';
import updateUserResponseSlice from './actions/updateUserResponseSlice';
import updateCollabStatusSlice from './actions/updateCollabStatusSlice';
import updateExceptionStatusSlice from './actions/updateExceptionStatusSlice';
import PowerBIActionDashboardSlice from './actions/PowerBIActionDashboardSlice';
import getPOExceptionMgmtBuyerFilter from './actions/getPOExceptionMgmtBuyerFilter';
import getViewParticularAnnouncementSlice from './actions/GetViewParticularAnnouncementSlice';
import getViewAllAnnouncementSlice from './actions/GetViewAllAnnouncementSlice';
import getAllSupplierAnnouncementSlice from './actions/GetAllSupplierAnnouncementSlice';
import postAnnouncementSlice from './actions/postAnnouncementSlice';
import getUnreadCountAnnouncementsSlice from './actions/getUnreadCountAnnouncementsSlice';
import postreadCountAnnouncementsSlice from './actions/postreadCountAnnouncementsSlice';
import addAppAdminTrainingTopicSlice from './actions/addAppAdminTrainingTopicSlice';
import updateAppAdminTrainingTopicSlice from './actions/updateAppAdminTrainingTopicSlice';
import deleteAppAdminTrainingTopicSlice from './actions/deleteAppAdminTrainingTopicSlice';
import getAppAdminTrainingTopicSlice from './actions/getAppAdminTrainingTopicSlice';
import getPlantLevelConfigByIdSlice from './actions/getPlantLevelConfigByIdSlice';
import getPlantLevelConfigSlice from './actions/getPlantLevelConfigSlice';
import serachPlantLevelConfigSlice from './actions/serachPlantLevelConfigSlice';
import postPlantLevelConfigSlice from './actions/postPlantLevelConfigSlice';
import putPlantLevelConfigSlice from './actions/putPlantLevelConfigSlice';
import deletePlantLevelConfigSlice from './actions/deletePlantLevelConfigSlice';
import dropdownPlantLevelConfigSlice from './actions/dropdownPlantLevelConfigSlice';
import getAlertObsoleteSlice from './actions/getAlertObsoleteSlice';
import getAlertObsoleteunreadCountSlice from './actions/getAlertObsoleteunreadCountSlice';
import putAlertObsoletereadCountSlice from './actions/putAlertObsoletereadCountSlice';
import postRestrictRuleSlice from './actions/postRestrictRuleSlice';
import getAllRestrictionRuleSlice from './actions/getAllRestrictionRuleSlice';
import deleteRestrictionRuleSlice from './actions/deleteRestrictionRuleSlice';
import putRestrictionRuleSlice from './actions/putRestrictionRuleSlice';
import searchRestrictionRuleSlice from './actions/searchRestrictionRuleSlice';
import postSupportTicketSlice from './actions/postSupportTicketSlice';
import getAlerImmutableauditSlice from './actions/getAlerImmutableauditSlice';
import getAlertImmutableauditunreadCountSlice from './actions/getAlertImmutableauditunreadCountSlice';
import putAlertImmutableauditreadCountSlice from './actions/putAlertImmutableauditreadCountSlice'
import getPoAccessRoleSlice from './actions/getPoAccessRoleSlice'
import getTicketSummaryDetailsSlice from './actions/getTicketSummaryDetailsSlice';
import getAlertSupplierConfirmationSlice from './actions/getAlertSupplierConfirmationSlice';
import putAlertSupplierConfimationreadCountSlice from './actions/putAlertSupplierConfimationreadCountSlice';
import getAlertSupplierConfirmationunreadCountSlice from './actions/getAlertSupplierConfirmationunreadCountSlice';
import getForecastHistoryFilterDataSlice from './actions/getForecastHistoryFilterDataSlice';
import getForecastHistorySearchSlice from './actions/getForecastHistorySearchSlice';
import postForecastHistoryDownloadSlice from './actions/postForecastHistoryDownloadSlice';
import getForecastHistoryDownloadListSlice from './actions/getForecastHistoryDownloadListSlice';
import getBuyerForecastHistoryNotificationsSlice from './actions/getBuyerForecastHistoryNotificationsSlice';
import getBuyerForecastHistoryNotificationsUnreadCountSlice from './actions/getBuyerForecastHistoryNotificationsUnreadCountSlice';
import putBuyerForecastHistoryNotificationsReadSlice from './actions/putBuyerForecastHistoryNotificationsReadSlice';
import getAlertSupplierUnconfirmedConsolidatedSlice from './actions/getAlertSupplierUnconfirmedConsolidatedSlice';
import getAlertSupplierUnconfirmedConsolidatedunreadCountSlice from './actions/getAlertSupplierUnconfirmedConsolidatedunreadCountSlice';
import putAlertSupplierUnconfirmedConsolidatedreadCountSlice from './actions/putAlertSupplierUnconfirmedConsolidatedreadCountSlice';
import gridSelectedRowsSlice from './actions/gridSelectedRowsSlice';
import getDropdownExtractForecastFromSAPSlice from './actions/getDropdownExtractForecastFromSAPSlice';
import postExtractForecastFromSAPSlice from './actions/postExtractForecastFromSAPSlice';
import getDomainListSlice from './actions/getDomainListSlice';
import postUploadDomainSlice from './actions/postUploadDomainSlice';
import postWhitelistDomainSlice from './actions/postWhitelistDomainSlice';
import postBlacklistDomainSlice from './actions/postBlacklistDomainSlice';
import getDomainDashboardSummarySlice from './actions/getDomainDashboardSummarySlice';
import getScheduledJobsSlice from './actions/getScheduledJobsSlice';
import getScheduledJobDetailSlice from './actions/getScheduledJobDetailSlice';
import NewVariantSlice from './actions/VariantView/NewVariantSlice';
import GetVariantsListSlice from './actions/VariantView/GetVariantsListSlice';
import EditVariantSlice from './actions/VariantView/EditVariantSlice';
import DeleteVariantSlice from './actions/VariantView/DeleteVariantSlice';
import GetShareUserSlice from './actions/VariantView/GetShareUserSlice';
import PostShareVariantSlice from './actions/VariantView/PostShareVariantSlice';
import postSaveVarientSlice from './actions/postSaveVarientSlice';
import getSaveVarientSlice from './actions/getSaveVarientSlice';
import editSaveVarientSlice from './actions/editSaveVarientSlice';
import deleteSaveVarientSlice from './actions/deleteSaveVarientSlice';
import shareSaveVarientSlice from './actions/shareSaveVarientSlice';
import getAllUsersDetailsSlice from './actions/getAllUsersDetailsSlice';
import GetAllVendorForecastExtractFromSAPSlice from './actions/GetAllVendorForecastExtractFromSAPSlice';
import postAddDomainSlice from './actions/postAddDomainSlice';

export const store = configureStore({
  reducer: {
    apiData: apiSlice,
    dashboardDetails: dashboardTitle,
    setRoleStore: setRoleStore,
    userCardType: userTypeSlice,
    GetHeaderRolesSlice: GetHeaderRolesSlice,
    SupplierDropdownListSlice: SupplierDropdownListSlice,
    SupplierDropdownFilterSlice: SupplierDropdownFilterSlice,
    PostInviteSupplierListSlice: PostInviteSupplierListSlice,
    GetAdminSupplierUserListSlice: GetAdminSupplierUserListSlice,
    DeleteAdminSupplierSlice: DeleteAdminSupplierSlice,
    GetEmailDomainSupplierListSlice: GetEmailDomainSupplierListSlice,
    SupplierForecastTableDataSlice: SupplierForecastTableDataReducer,
    SupplierForecastSearchTableSlice: SupplierForecastSearchTableReducer,
    ForecastHistoryTableSlice: ForecastHistoryTableReducer,
    PUTEditInviteUserSlice: PUTEditInviteUserSlice,
    SupplierForecastSaveDataSlice: SupplierForecastSaveDataReducer,
    PostHideColumnsSlice: PostHideColumnsSlice,
    GetHideColumnsListSlice: GetHideColumnsListSlice,
    FileUploadSlice: FileUploadSlice,
    getForecastHistoryFilterDataSlice: getForecastHistoryFilterDataSlice,
    getForecastHistorySearchSlice: getForecastHistorySearchSlice,
    postForecastHistoryDownloadSlice: postForecastHistoryDownloadSlice,
    getForecastHistoryDownloadListSlice: getForecastHistoryDownloadListSlice,
    getBuyerForecastHistoryNotificationsSlice: getBuyerForecastHistoryNotificationsSlice,
    getBuyerForecastHistoryNotificationsUnreadCountSlice: getBuyerForecastHistoryNotificationsUnreadCountSlice,
    putBuyerForecastHistoryNotificationsReadSlice: putBuyerForecastHistoryNotificationsReadSlice,
    getforecastEmailSlice: getforecastEmailSlice,
    getReasonCodeSlice: getReasonCodeSlice,
    putEditReasonCodeSlice: putEditReasonCodeSlice,
    postReasonCodeSlice: postReasonCodeSlice,
    deleteReasonCodeSlice: deleteReasonCodeSlice,
    getBuyerDropdownFilter: getBuyerDropdownFilter,
    getBuyerForecastTableData: getBuyerForecastTableData,
    getBuyerForecastSearchTable: getBuyerForecastSearchTable,
    getBuyerForecastSaveDataSlice: getBuyerForecastSaveDataSlice,
    submitBuyerForecastOverrideDataSlice: submitBuyerForecastOverrideDataSlice,
    getPOExceptionMgmtBuyerTable: getPOExceptionMgmtBuyerTable,
    getMaterialBatchData: getMaterialBatchData,
    setRegionPlantStore: setRegionPlantStore,
    getPlantRegionSlice: getPlantsRegionSlice,
    getSupplierEmails: getSupplierEmailsSlice,
    addToSupplierEmails: addToSupplierEmailsSlice,
    sendMailToSupplier: sendMailToSupplierSlice,
    sendToSupplier: sendToSupplierSlice,
    getSupplierPortalData: getSupplierPortalDataSlice,
    updateUserResponse: updateUserResponseSlice,
    updateCollabStatus: updateCollabStatusSlice,
    updateExceptionStatus: updateExceptionStatusSlice,
    PowerBIActionDashboardSlice: PowerBIActionDashboardSlice,
    getPOExceptionMgmtBuyerFilter: getPOExceptionMgmtBuyerFilter,
    getViewParticularAnnouncementSlice: getViewParticularAnnouncementSlice,
    getViewAllAnnouncementSlice: getViewAllAnnouncementSlice,
    getAllSupplierAnnouncementSlice: getAllSupplierAnnouncementSlice,
    postAnnouncementSlice: postAnnouncementSlice,
    getUnreadCountAnnouncementsSlice: getUnreadCountAnnouncementsSlice,
    postreadCountAnnouncementsSlice: postreadCountAnnouncementsSlice,
    addAppAdminTrainingTopicSlice: addAppAdminTrainingTopicSlice,
    updateAppAdminTrainingTopicSlice: updateAppAdminTrainingTopicSlice,
    deleteAppAdminTrainingTopicSlice: deleteAppAdminTrainingTopicSlice,
    getAppAdminTrainingTopicSlice: getAppAdminTrainingTopicSlice,
    getPlantLevelConfigByIdSlice: getPlantLevelConfigByIdSlice,
    postPlantLevelConfigSlice: postPlantLevelConfigSlice,
    getPlantLevelConfigSlice: getPlantLevelConfigSlice,
    putPlantLevelConfigSlice: putPlantLevelConfigSlice,
    serachPlantLevelConfigSlice: serachPlantLevelConfigSlice,
    deletePlantLevelConfigSlice: deletePlantLevelConfigSlice,
    dropdownPlantLevelConfigSlice: dropdownPlantLevelConfigSlice,
    getAlertObsoleteSlice: getAlertObsoleteSlice,
    getAlertObsoleteunreadCountSlice: getAlertObsoleteunreadCountSlice,
    putAlertObsoletereadCountSlice: putAlertObsoletereadCountSlice,
    postRestrictRuleSlice: postRestrictRuleSlice,
    getAllRestrictionRuleSlice: getAllRestrictionRuleSlice,
    deleteRestrictionRuleSlice: deleteRestrictionRuleSlice,
    putRestrictionRuleSlice: putRestrictionRuleSlice,
    searchRestrictionRuleSlice: searchRestrictionRuleSlice,
    postSupportTicketSlice: postSupportTicketSlice,
    getAlerImmutableauditSlice: getAlerImmutableauditSlice,
    getAlertImmutableauditunreadCountSlice: getAlertImmutableauditunreadCountSlice,
    putAlertImmutableauditreadCountSlice: putAlertImmutableauditreadCountSlice,
    getPoAccessRoleSlice: getPoAccessRoleSlice,
    getTicketSummaryDetailsSlice: getTicketSummaryDetailsSlice,
    getAlertSupplierConfirmationSlice: getAlertSupplierConfirmationSlice,
    putAlertSupplierConfimationreadCountSlice: putAlertSupplierConfimationreadCountSlice,
    getAlertSupplierConfirmationunreadCountSlice: getAlertSupplierConfirmationunreadCountSlice,
    getAlertSupplierUnconfirmedConsolidatedSlice: getAlertSupplierUnconfirmedConsolidatedSlice,
    getAlertSupplierUnconfirmedConsolidatedunreadCountSlice: getAlertSupplierUnconfirmedConsolidatedunreadCountSlice,
    putAlertSupplierUnconfirmedConsolidatedreadCountSlice: putAlertSupplierUnconfirmedConsolidatedreadCountSlice,
    getDropdownExtractForecastFromSAPSlice: getDropdownExtractForecastFromSAPSlice,
    postExtractForecastFromSAPSlice: postExtractForecastFromSAPSlice,
    gridSelectedRows: gridSelectedRowsSlice,
    getDomainListSlice: getDomainListSlice,
    postUploadDomainSlice: postUploadDomainSlice,
    postWhitelistDomainSlice: postWhitelistDomainSlice,
    postBlacklistDomainSlice: postBlacklistDomainSlice,
    getDomainDashboardSummarySlice: getDomainDashboardSummarySlice,
    getScheduledJobsSlice: getScheduledJobsSlice,
    getScheduledJobDetailSlice: getScheduledJobDetailSlice,
    NewVariantSlice: NewVariantSlice,
    GetVariantsListSlice: GetVariantsListSlice,
    EditVariantSlice: EditVariantSlice,
    DeleteVariantSlice: DeleteVariantSlice,
    GetShareUserSlice: GetShareUserSlice,
    PostShareVariantSlice: PostShareVariantSlice,
    postSaveVarientSlice: postSaveVarientSlice,
    getSaveVarientSlice: getSaveVarientSlice,
    editSaveVarientSlice: editSaveVarientSlice,
    deleteSaveVarientSlice: deleteSaveVarientSlice,
    shareSaveVarientSlice: shareSaveVarientSlice,
    getAllUsersDetailsSlice: getAllUsersDetailsSlice,
    GetAllVendorForecastExtractFromSAPSlice: GetAllVendorForecastExtractFromSAPSlice,
    postAddDomainSlice: postAddDomainSlice
  },
})